import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import "./SupplierImport.scss";

import {
  BsQuestionCircle,

} from "react-icons/bs";
import { BiSearch, BiShareAlt, BiTrash, BiChevronRight } from "react-icons/bi";
import { CgSortAz } from "react-icons/cg";

function ImportFileSelected({ t, file, callbackSelected }) {
  const handleContinueEdit = () => {
    let obj = {
      type: "Continue",
    };
    callbackSelected(obj);
  };
  const handleBack = () => {
    let obj = {
        type: "Back"
    };
    callbackSelected(obj);
}

  return (
    <div className="Start_importCard">
      <div className="Start_importCard_head">
        <h6>
        {t("Youhaveselectedonedatafiletobeimported.label")}
        </h6>
        {file.name}
      </div>
      <div className="text-start p-2">
            <button type="button" className="btn btn-secondary me-2 px-4" onClick={handleBack}>
              {t("Back.label")}
            </button>
            <button
              type="button"
              className="btn btn-primary px-4"
               onClick={handleContinueEdit}
            >
             {t("Continue.label")}
            </button>
          </div>
     
    </div>
  );
}
export default withTranslation()(ImportFileSelected);
